export default {
  getTemplateConfiguration(config) {
    switch (config) {
      // Proposta di struttura template che si potrebbe applicare per rendere chiara la suddivisione delle colonne in contesti nidificati
      /*
            case "LAYOUT_UNIDATO_ESEMPIO": {
                return {
                    label: 'col-6',
                    um: 'col-2',
                    editor_container: 'col-4',
                    editor :
                    {
                        input: 'col-6',
                        output1: 'col-6',
                        output2: ''
                    }
                }
            }
            case "LAYOUT_CORRELATOR_ESEMPIO": {
                return {
                    correlator: 'col-6',
                    unidato_container:'col-6',
                    unidato :
                    {
                        label: '',
                        um: 'col-4',
                        editor_container: 'col-8',
                        editorValues :
                        {
                            input: 'col-12',
                            output1: '',
                            output2: ''
                        }
                    }
                }
            }
            */
      // Behaviour per i Correlator
      case "TWO_COLUMN_UM_INPUT": {
        return {
          label: "",
          um: "col-4",
          input: "col-12",
          output1: "",
          output2: ""
        };
      }
      case "TWO_COLUMN_UM_OUTPUT": {
        return {
          label: "",
          um: "col-4",
          input: "",
          output1: "col-12",
          output2: ""
        };
      }
      case "TWO_COLUMN_UM_BALANCED_OUTPUT": {
        return {
          label: "",
          um: "col-4",
          input: "",
          output1: "",
          output2: "col-12"
        };
      }
      case "TWO_COLUMN_UM_INPUT_OR_OUTPUT": {
        return {
          label: "",
          um: "col-4",
          input: "col-12",
          output1: "col-12",
          output2: ""
        };
      }

      // Behaviour con UM nascosta
      case "THREE_COLUMN_LABEL_INPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-12",
          output1: "",
          output2: ""
        };
      }
      case "THREE_COLUMN_LABEL_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "col-12",
          output2: ""
        };
      }
      case "THREE_COLUMN_LABEL_BALANCED_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "",
          output2: "col-12"
        };
      }
      case "FOUR_COLUMN_LABEL_INPUT_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-6",
          output1: "col-6",
          output2: ""
        };
      }
      case "FOUR_COLUMN_LABEL_INPUT_BALANCED_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-6",
          output1: "",
          output2: "col-6"
        };
      }
      case "FOUR_COLUMN_LABEL_BALANCED_OUTPUT_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "col-6",
          output2: "col-6"
        };
      }
      case "FIVE_COLUMN_LABEL_INPUT_BALANCED_OUTPUT_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-4",
          output1: "col-4",
          output2: "col-4"
        };
      }

      // Behaviour con UM Visibile
      case "THREE_COLUMN_LABEL_UM_INPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-12",
          output1: "",
          output2: ""
        };
      }
      case "THREE_COLUMN_LABEL_UM_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "col-12",
          output2: ""
        };
      }
      case "THREE_COLUMN_LABEL_UM_BALANCED_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "",
          output2: "col-12"
        };
      }
      case "THREE_COLUMN_UM_INPUT_OUTPUT": {
        return {
          label: "",
          um: "col-2",
          input: "col-6",
          output1: "col-6",
          output2: ""
        };
      }
      case "FOUR_COLUMN_LABEL_UM_INPUT_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-6",
          output1: "col-6",
          output2: ""
        };
      }
      case "FOUR_COLUMN_LABEL_UM_INPUT_BALANCED_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-6",
          output1: "",
          output2: "col-6"
        };
      }
      case "FOUR_COLUMN_LABEL_UM_BALANCED_OUTPUT_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "col-6",
          output2: "col-6"
        };
      }
      case ("FOUR_COLUMN_LABEL_UM_INPUT", "FOUR_COLUMN_LABEL_UM_OUTPUT"): {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-6",
          output1: "col-6",
          output2: ""
        };
      }
      case "FOUR_COLUMN_LABEL_UM_BALANCED_OUTPUT": {
        return {
          label: "col-6",
          um: "col-2",
          input: "",
          output1: "col-6",
          output2: "col-6"
        };
      }
      case ("FIVE_COLUMN_LABEL_UM_INPUT_BALANCED_OUTPUT_OUTPUT",
      "FIVE_COLUMN_LABEL_UM_INPUT",
      "FIVE_COLUMN_LABEL_UM_INPUT_OUTPUT",
      "FIVE_COLUMN_LABEL_UM_INPUT_BALANCED_OUTPUT",
      "FIVE_COLUMN_LABEL_UM_BALANCED_OUTPUT_OUTPUT",
      "FIVE_COLUMN_LABEL_UM_OUTPUT",
      "FIVE_COLUMN_LABEL_UM_BALANCED_OUTPUT"): {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-4",
          output1: "col-4",
          output2: "col-4"
        };
      }
      default: {
        return {
          label: "col-6",
          um: "col-2",
          input: "col-4",
          output1: "col-4",
          output2: "col-4"
        };
      }
    }
  }
};
